import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { POST, PUT, GET, httpOk } from 'helpers/api'
import { formatDate, returnSign } from 'helpers/helpers'
import { useDispatch } from "react-redux"
import { SET_SETTINGS } from "store/settings/actions"

function Index() {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const [showModal, setShowModal] = useState(false)
	const [filterData, setFilterData] = useState({
		search: '',
	})
	const [pagination, setPagination] = useState({
		url: '/currency',
		response: null
	})
	const [selectedItem, setSelectedItem] = useState({
		rate: "",
	})
	const [data, setData] = useState([])

	async function createUpdate(e) {
		e.preventDefault()
		var selectedItemCopy = { ...selectedItem }
		var response;
		if (selectedItemCopy.id) {
			response = await PUT('/currency', selectedItemCopy, { loader: true })
		} else {
			response = await POST('/currency', selectedItemCopy, { loader: true })
		}

		if (httpOk(response)) {
			dispatch(SET_SETTINGS({ currency: selectedItemCopy.rate }))
			searchWithFilter()
			toggleModal(false)
		}
	}

	async function searchWithFilter() {
		var filterUrl = "/currency"
		var urlParams = ""

		if (filterData.status)
			urlParams += returnSign(urlParams) + 'currency=' + filterData.currency
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search
		if (filterData.page)
			urlParams += returnSign(urlParams) + 'page=' + filterData.page
		if (filterData.size)
			urlParams += returnSign(urlParams) + 'size=' + filterData.size

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	function toggleModal(bool, item) {
		if (bool) {
			var itemCopy = { ...item }
			setSelectedItem(itemCopy)
			setShowModal(true)
		} else {
			setSelectedItem({})
			setShowModal(false)
		}
	}

	useEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('currency')} [{data.total}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => setShowModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
						</div>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '10%' }}>{t('rate')}</th>
									<th style={{ 'width': '80%' }}></th>
									<th style={{ 'width': '10%' }} className="text-center">{t('date')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">
											{item.row_number}
										</td>
										<td className="td-ellipsis" title={item.rate}>{item.rate}</td>
										<td></td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										{/* <td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td> */}
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered dialogClassName="update-modal-width"
				backdrop="static" onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem.id ?
							<>{t('edit')}</>
							:
							<>{t('create')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('rate')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="rate"
								value={selectedItem.rate ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'rate': e.target.value })} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Index
